import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class RatingService {
	public static ratingGetSetting(input: any) {
		return Http.axios()
			.get("/api/Rating/GetDabRatingSettings", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static ratingUpdateSetting(input: any) {
		return Http.axios()
			.post("/api/Rating/UpdateDabRatingSettings", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static ratingGetDashboard(input: any) {
		return Http.axios()
			.post("/api/Rating/dashboard", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static ratingGetAppVersions(input: any) {
		return Http.axios()
			.get("/api/Rating/config/appversions", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static ratingDelete(userRatingId: any) {
		return Http.axios()
			.delete("/api/Rating/delete/" + userRatingId, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}